import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material/icon';

@Component({
  selector: 'neq-icon',
  templateUrl: './icon.component.html',
})
export class NeqIconComponent implements OnInit {

  @Input() svgIcon: string;

  constructor(private readonly iconRegistry: MatIconRegistry, private readonly sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.iconRegistry.addSvgIcon(this.svgIcon, this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${this.svgIcon}.svg`));
  }

}
